// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"_a80b3b4"};